// Device fixes are memory-only and never inferred from gym locations.
export const POSITION_PERMISSION_GRANTED_EVENT = 'katafit-device-location-granted';
// A device check belongs to the authenticated root lifecycle that initiated it,
// not whichever owner happens to be mounted when its device callback completes.
let permissionScope = null;
export function createPositionPermissionScope(owner) {
  const scope = { owner };
  permissionScope = scope;
  return {
    scope,
    dispose() { if (permissionScope === scope) permissionScope = null; },
  };
}
export const getPositionPermissionScope = () => permissionScope;
export const POSITION_WATCH_OPTIONS = { enableHighAccuracy: false, maximumAge: 60000, timeout: 15000 };
export function createPositionRuntime({ geolocation, foreground, subscribe, onPermissionDenied }) {
  let owner = null, consent = false, active = foreground(), watch = null, fix = null, generation = 0, disposed = false;
  const stop = () => {
    generation++; fix = null;
    if (watch !== null) geolocation?.clearWatch(watch);
    watch = null;
  };
  const start = () => {
    if (!owner || !consent || !active || watch !== null || !geolocation?.watchPosition) return;
    const epoch = ++generation;
    watch = geolocation.watchPosition(position => {
      if (epoch !== generation) return;
      const { latitude, longitude, accuracy } = position?.coords || {};
      const age = Date.now() - position?.timestamp;
      if (!Number.isFinite(position?.timestamp) || age > 60000 || age < -5000 ||
          !Number.isFinite(latitude) || latitude < -90 || latitude > 90 ||
          !Number.isFinite(longitude) || longitude < -180 || longitude > 180 ||
          !Number.isFinite(accuracy) || accuracy < 0 || accuracy > 10000) { fix = null; return; }
      fix = { owner_user_id: owner, latitude, longitude, accuracy, source: 'gps', captured_at: new Date(position.timestamp).toISOString() };
    }, error => {
      if (epoch !== generation) return;
      if (error?.code !== 3) fix = null;
      if (error?.code === 1) { consent = false; stop(); onPermissionDenied?.(); }
    }, { enableHighAccuracy: true, maximumAge: 0, timeout: 15000, owner_user_id: owner });
  };
  const unsubscribe = subscribe(next => { active = next; if (active) start(); else stop(); });
  return {
    configure(nextOwner, enabled) {
      if (disposed) return;
      if (owner !== nextOwner || consent !== enabled) { stop(); owner = nextOwner; consent = enabled === true; }
      start();
    },
    snapshot(expectedOwner) {
      const age = fix ? Date.now() - Date.parse(fix.captured_at) : Infinity;
      return active && consent && owner === expectedOwner && fix && age <= 60000 && age >= -5000 ? { ...fix } : null;
    },
    dispose() { if (disposed) return; disposed = true; stop(); unsubscribe(); owner = null; consent = false; },
  };
}
